/**
 * 搭乗証明書の検索条件タイプ
 */
export type BoardingCertificateSearchConditionBy =
  (typeof BoardingCertificateSearchConditionBy)[keyof typeof BoardingCertificateSearchConditionBy];

export const BoardingCertificateSearchConditionBy = {
  /** 出発日 */
  DEPARTURE_DATE: 0,
  /** 購入日 */
  PURCHASE_DATE: 1,
  /** 航空券番号 */
  TICKET: 2,
} as const;
